export enum ActionTypes {
 GET_ALL_ACCOUNT_POINTS = '[GET_ALL_ACCOUNT_POINTS] Get all account points',
 GET_ALL_ACCOUNT_POINTS_SUCCESS = '[GET_ALL_ACCOUNT_POINTS] Get all account points success',
 GET_ALL_ACCOUNT_POINTS_FAILURE = '[GET_ALL_ACCOUNT_POINTS] Get all account points failure',
 CLEAR_GET_ALL_ACCOUNT_POINTS = '[GET_ALL_ACCOUNT_POINTS] Clear all account points',
 GET_ALL_ACCOUNT_POINTS_BULK_ASSIGN_TAGS = '[GET_ALL_ACCOUNT_POINTS] Bulk assign tags',
 GET_ALL_ACCOUNT_POINTS_BULK_REMOVE_TAGS = '[GET_ALL_ACCOUNT_POINTS] Bulk remove tags',
 GET_ALL_ACCOUNT_POINTS_BULK_ASSIGN_CATEGORY = '[GET_ALL_ACCOUNT_POINTS] Bulk assign category',
 GET_ALL_ACCOUNT_POINTS_BULK_UPDATE_ACCOUNTS_TYPE = '[GET_ALL_ACCOUNT_POINTS] Bulk update accounts type',
 GET_ALL_ACCOUNT_POINTS_BULK_ASSIGN_ACCOUNTS = '[GET_ALL_ACCOUNT_POINTS] Bulk assign accounts',
 GET_ALL_ACCOUNT_POINTS_BULK_REMOVE_ACCOUNTS = '[GET_ALL_ACCOUNT_POINTS] Bulk remove accounts',
}
